/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

const StakingLayout = ({ children }) => (
  <>
    {/* browser layout */}
    <div className="d-none d-md-flex card-layout px-0 container-md mt-3 mt-md-5 w-100">
      <div className="mx-0 row">{children}</div>
    </div>
    {/* mobile layout */}
    <div className="d-block d-md-none card-layout mt-5">
      <div className="mx-0 mb-5 pb-5">{children}</div>
    </div>
  </>
);

export default StakingLayout;

StakingLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
